export const Account = 1;
export const AdvId = 2;
export const AdvRefID = 3;
export const AdvSide = 4;
export const AdvTransType = 5;
export const AvgPx = 6;
export const BeginSeqNo = 7;
export const BeginString = 8;
export const BodyLength = 9;
export const CheckSum = 10;
export const ClOrdID = 11;
export const Commission = 12;
export const CommType = 13;
export const CumQty = 14;
export const Currency = 15;
export const EndSeqNo = 16;
export const ExecID = 17;
export const ExecInst = 18;
export const ExecRefID = 19;
export const HandlInst = 21;
export const SecurityIDSource = 22;
export const IOIID = 23;
export const IOIQltyInd = 25;
export const IOIRefID = 26;
export const IOIQty = 27;
export const IOITransType = 28;
export const LastCapacity = 29;
export const LastMkt = 30;
export const LastPx = 31;
export const LastQty = 32;
export const NoLinesOfText = 33;
export const MsgSeqNum = 34;
export const MsgType = 35;
export const NewSeqNo = 36;
export const OrderID = 37;
export const OrderQty = 38;
export const OrdStatus = 39;
export const OrdType = 40;
export const OrigClOrdID = 41;
export const OrigTime = 42;
export const PossDupFlag = 43;
export const Price = 44;
export const RefSeqNum = 45;
export const SecurityID = 48;
export const SenderCompID = 49;
export const SenderSubID = 50;
export const SendingTime = 52;
export const Quantity = 53;
export const Side = 54;
export const Symbol = 55;
export const TargetCompID = 56;
export const TargetSubID = 57;
export const Text = 58;
export const TimeInForce = 59;
export const TransactTime = 60;
export const Urgency = 61;
export const ValidUntilTime = 62;
export const SettlType = 63;
export const SettlDate = 64;
export const SymbolSfx = 65;
export const ListID = 66;
export const ListSeqNo = 67;
export const TotNoOrders = 68;
export const ListExecInst = 69;
export const AllocID = 70;
export const AllocTransType = 71;
export const RefAllocID = 72;
export const NoOrders = 73;
export const AvgPxPrecision = 74;
export const TradeDate = 75;
export const PositionEffect = 77;
export const NoAllocs = 78;
export const AllocAccount = 79;
export const AllocQty = 80;
export const ProcessCode = 81;
export const NoRpts = 82;
export const RptSeq = 83;
export const CxlQty = 84;
export const NoDlvyInst = 85;
export const AllocStatus = 87;
export const AllocRejCode = 88;
export const Signature = 89;
export const SecureDataLen = 90;
export const SecureData = 91;
export const SignatureLength = 93;
export const EmailType = 94;
export const RawDataLength = 95;
export const RawData = 96;
export const PossResend = 97;
export const EncryptMethod = 98;
export const StopPx = 99;
export const ExDestination = 100;
export const CxlRejReason = 102;
export const OrdRejReason = 103;
export const IOIQualifier = 104;
export const Issuer = 106;
export const SecurityDesc = 107;
export const HeartBtInt = 108;
export const MinQty = 110;
export const MaxFloor = 111;
export const TestReqID = 112;
export const ReportToExch = 113;
export const LocateReqd = 114;
export const OnBehalfOfCompID = 115;
export const OnBehalfOfSubID = 116;
export const QuoteID = 117;
export const NetMoney = 118;
export const SettlCurrAmt = 119;
export const SettlCurrency = 120;
export const ForexReq = 121;
export const OrigSendingTime = 122;
export const GapFillFlag = 123;
export const NoExecs = 124;
export const ExpireTime = 126;
export const DKReason = 127;
export const DeliverToCompID = 128;
export const DeliverToSubID = 129;
export const IOINaturalFlag = 130;
export const QuoteReqID = 131;
export const BidPx = 132;
export const OfferPx = 133;
export const BidSize = 134;
export const OfferSize = 135;
export const NoMiscFees = 136;
export const MiscFeeAmt = 137;
export const MiscFeeCurr = 138;
export const MiscFeeType = 139;
export const PrevClosePx = 140;
export const ResetSeqNumFlag = 141;
export const SenderLocationID = 142;
export const TargetLocationID = 143;
export const OnBehalfOfLocationID = 144;
export const DeliverToLocationID = 145;
export const NoRelatedSym = 146;
export const Subject = 147;
export const Headline = 148;
export const URLLink = 149;
export const ExecType = 150;
export const LeavesQty = 151;
export const CashOrderQty = 152;
export const AllocAvgPx = 153;
export const AllocNetMoney = 154;
export const SettlCurrFxRate = 155;
export const SettlCurrFxRateCalc = 156;
export const NumDaysInterest = 157;
export const AccruedInterestRate = 158;
export const AccruedInterestAmt = 159;
export const SettlInstMode = 160;
export const AllocText = 161;
export const SettlInstID = 162;
export const SettlInstTransType = 163;
export const EmailThreadID = 164;
export const SettlInstSource = 165;
export const SecurityType = 167;
export const EffectiveTime = 168;
export const StandInstDbType = 169;
export const StandInstDbName = 170;
export const StandInstDbID = 171;
export const SettlDeliveryType = 172;
export const BidSpotRate = 188;
export const BidForwardPoints = 189;
export const OfferSpotRate = 190;
export const OfferForwardPoints = 191;
export const OrderQty2 = 192;
export const SettlDate2 = 193;
export const LastSpotRate = 194;
export const LastForwardPoints = 195;
export const AllocLinkID = 196;
export const AllocLinkType = 197;
export const SecondaryOrderID = 198;
export const NoIOIQualifiers = 199;
export const MaturityMonthYear = 200;
export const PutOrCall = 201;
export const StrikePrice = 202;
export const CoveredOrUncovered = 203;
export const OptAttribute = 206;
export const SecurityExchange = 207;
export const NotifyBrokerOfCredit = 208;
export const AllocHandlInst = 209;
export const MaxShow = 210;
export const PegOffsetValue = 211;
export const XmlDataLen = 212;
export const XmlData = 213;
export const SettlInstRefID = 214;
export const NoRoutingIDs = 215;
export const RoutingType = 216;
export const RoutingID = 217;
export const Spread = 218;
export const BenchmarkCurveCurrency = 220;
export const BenchmarkCurveName = 221;
export const BenchmarkCurvePoint = 222;
export const CouponRate = 223;
export const CouponPaymentDate = 224;
export const IssueDate = 225;
export const RepurchaseTerm = 226;
export const RepurchaseRate = 227;
export const Factor = 228;
export const TradeOriginationDate = 229;
export const ExDate = 230;
export const ContractMultiplier = 231;
export const NoStipulations = 232;
export const StipulationType = 233;
export const StipulationValue = 234;
export const YieldType = 235;
export const Yield = 236;
export const TotalTakedown = 237;
export const Concession = 238;
export const RepoCollateralSecurityType = 239;
export const RedemptionDate = 240;
export const UnderlyingCouponPaymentDate = 241;
export const UnderlyingIssueDate = 242;
export const UnderlyingRepoCollateralSecurityType = 243;
export const UnderlyingRepurchaseTerm = 244;
export const UnderlyingRepurchaseRate = 245;
export const UnderlyingFactor = 246;
export const UnderlyingRedemptionDate = 247;
export const LegCouponPaymentDate = 248;
export const LegIssueDate = 249;
export const LegRepoCollateralSecurityType = 250;
export const LegRepurchaseTerm = 251;
export const LegRepurchaseRate = 252;
export const LegFactor = 253;
export const LegRedemptionDate = 254;
export const CreditRating = 255;
export const UnderlyingCreditRating = 256;
export const LegCreditRating = 257;
export const TradedFlatSwitch = 258;
export const BasisFeatureDate = 259;
export const BasisFeaturePrice = 260;
export const MDReqID = 262;
export const SubscriptionRequestType = 263;
export const MarketDepth = 264;
export const MDUpdateType = 265;
export const AggregatedBook = 266;
export const NoMDEntryTypes = 267;
export const NoMDEntries = 268;
export const MDEntryType = 269;
export const MDEntryPx = 270;
export const MDEntrySize = 271;
export const MDEntryDate = 272;
export const MDEntryTime = 273;
export const TickDirection = 274;
export const MDMkt = 275;
export const QuoteCondition = 276;
export const TradeCondition = 277;
export const MDEntryID = 278;
export const MDUpdateAction = 279;
export const MDEntryRefID = 280;
export const MDReqRejReason = 281;
export const MDEntryOriginator = 282;
export const LocationID = 283;
export const DeskID = 284;
export const DeleteReason = 285;
export const OpenCloseSettlFlag = 286;
export const SellerDays = 287;
export const MDEntryBuyer = 288;
export const MDEntrySeller = 289;
export const MDEntryPositionNo = 290;
export const FinancialStatus = 291;
export const CorporateAction = 292;
export const DefBidSize = 293;
export const DefOfferSize = 294;
export const NoQuoteEntries = 295;
export const NoQuoteSets = 296;
export const QuoteStatus = 297;
export const QuoteCancelType = 298;
export const QuoteEntryID = 299;
export const QuoteRejectReason = 300;
export const QuoteResponseLevel = 301;
export const QuoteSetID = 302;
export const QuoteRequestType = 303;
export const TotNoQuoteEntries = 304;
export const UnderlyingSecurityIDSource = 305;
export const UnderlyingIssuer = 306;
export const UnderlyingSecurityDesc = 307;
export const UnderlyingSecurityExchange = 308;
export const UnderlyingSecurityID = 309;
export const UnderlyingSecurityType = 310;
export const UnderlyingSymbol = 311;
export const UnderlyingSymbolSfx = 312;
export const UnderlyingMaturityMonthYear = 313;
export const UnderlyingPutOrCall = 315;
export const UnderlyingStrikePrice = 316;
export const UnderlyingOptAttribute = 317;
export const UnderlyingCurrency = 318;
export const SecurityReqID = 320;
export const SecurityRequestType = 321;
export const SecurityResponseID = 322;
export const SecurityResponseType = 323;
export const SecurityStatusReqID = 324;
export const UnsolicitedIndicator = 325;
export const SecurityTradingStatus = 326;
export const HaltReason = 327;
export const InViewOfCommon = 328;
export const DueToRelated = 329;
export const BuyVolume = 330;
export const SellVolume = 331;
export const HighPx = 332;
export const LowPx = 333;
export const Adjustment = 334;
export const TradSesReqID = 335;
export const TradingSessionID = 336;
export const ContraTrader = 337;
export const TradSesMethod = 338;
export const TradSesMode = 339;
export const TradSesStatus = 340;
export const TradSesStartTime = 341;
export const TradSesOpenTime = 342;
export const TradSesPreCloseTime = 343;
export const TradSesCloseTime = 344;
export const TradSesEndTime = 345;
export const NumberOfOrders = 346;
export const MessageEncoding = 347;
export const EncodedIssuerLen = 348;
export const EncodedIssuer = 349;
export const EncodedSecurityDescLen = 350;
export const EncodedSecurityDesc = 351;
export const EncodedListExecInstLen = 352;
export const EncodedListExecInst = 353;
export const EncodedTextLen = 354;
export const EncodedText = 355;
export const EncodedSubjectLen = 356;
export const EncodedSubject = 357;
export const EncodedHeadlineLen = 358;
export const EncodedHeadline = 359;
export const EncodedAllocTextLen = 360;
export const EncodedAllocText = 361;
export const EncodedUnderlyingIssuerLen = 362;
export const EncodedUnderlyingIssuer = 363;
export const EncodedUnderlyingSecurityDescLen = 364;
export const EncodedUnderlyingSecurityDesc = 365;
export const AllocPrice = 366;
export const QuoteSetValidUntilTime = 367;
export const QuoteEntryRejectReason = 368;
export const LastMsgSeqNumProcessed = 369;
export const RefTagID = 371;
export const RefMsgType = 372;
export const SessionRejectReason = 373;
export const BidRequestTransType = 374;
export const ContraBroker = 375;
export const ComplianceID = 376;
export const SolicitedFlag = 377;
export const ExecRestatementReason = 378;
export const BusinessRejectRefID = 379;
export const BusinessRejectReason = 380;
export const GrossTradeAmt = 381;
export const NoContraBrokers = 382;
export const MaxMessageSize = 383;
export const NoMsgTypes = 384;
export const MsgDirection = 385;
export const NoTradingSessions = 386;
export const TotalVolumeTraded = 387;
export const DiscretionInst = 388;
export const DiscretionOffsetValue = 389;
export const BidID = 390;
export const ClientBidID = 391;
export const ListName = 392;
export const TotNoRelatedSym = 393;
export const BidType = 394;
export const NumTickets = 395;
export const SideValue1 = 396;
export const SideValue2 = 397;
export const NoBidDescriptors = 398;
export const BidDescriptorType = 399;
export const BidDescriptor = 400;
export const SideValueInd = 401;
export const LiquidityPctLow = 402;
export const LiquidityPctHigh = 403;
export const LiquidityValue = 404;
export const EFPTrackingError = 405;
export const FairValue = 406;
export const OutsideIndexPct = 407;
export const ValueOfFutures = 408;
export const LiquidityIndType = 409;
export const WtAverageLiquidity = 410;
export const ExchangeForPhysical = 411;
export const OutMainCntryUIndex = 412;
export const CrossPercent = 413;
export const ProgRptReqs = 414;
export const ProgPeriodInterval = 415;
export const IncTaxInd = 416;
export const NumBidders = 417;
export const BidTradeType = 418;
export const BasisPxType = 419;
export const NoBidComponents = 420;
export const Country = 421;
export const TotNoStrikes = 422;
export const PriceType = 423;
export const DayOrderQty = 424;
export const DayCumQty = 425;
export const DayAvgPx = 426;
export const GTBookingInst = 427;
export const NoStrikes = 428;
export const ListStatusType = 429;
export const NetGrossInd = 430;
export const ListOrderStatus = 431;
export const ExpireDate = 432;
export const ListExecInstType = 433;
export const CxlRejResponseTo = 434;
export const UnderlyingCouponRate = 435;
export const UnderlyingContractMultiplier = 436;
export const ContraTradeQty = 437;
export const ContraTradeTime = 438;
export const LiquidityNumSecurities = 441;
export const MultiLegReportingType = 442;
export const StrikeTime = 443;
export const ListStatusText = 444;
export const EncodedListStatusTextLen = 445;
export const EncodedListStatusText = 446;
export const PartyIDSource = 447;
export const PartyID = 448;
export const NetChgPrevDay = 451;
export const PartyRole = 452;
export const NoPartyIDs = 453;
export const NoSecurityAltID = 454;
export const SecurityAltID = 455;
export const SecurityAltIDSource = 456;
export const NoUnderlyingSecurityAltID = 457;
export const UnderlyingSecurityAltID = 458;
export const UnderlyingSecurityAltIDSource = 459;
export const Product = 460;
export const CFICode = 461;
export const UnderlyingProduct = 462;
export const UnderlyingCFICode = 463;
export const TestMessageIndicator = 464;
export const BookingRefID = 466;
export const IndividualAllocID = 467;
export const RoundingDirection = 468;
export const RoundingModulus = 469;
export const CountryOfIssue = 470;
export const StateOrProvinceOfIssue = 471;
export const LocaleOfIssue = 472;
export const NoRegistDtls = 473;
export const MailingDtls = 474;
export const InvestorCountryOfResidence = 475;
export const PaymentRef = 476;
export const DistribPaymentMethod = 477;
export const CashDistribCurr = 478;
export const CommCurrency = 479;
export const CancellationRights = 480;
export const MoneyLaunderingStatus = 481;
export const MailingInst = 482;
export const TransBkdTime = 483;
export const ExecPriceType = 484;
export const ExecPriceAdjustment = 485;
export const DateOfBirth = 486;
export const TradeReportTransType = 487;
export const CardHolderName = 488;
export const CardNumber = 489;
export const CardExpDate = 490;
export const CardIssNum = 491;
export const PaymentMethod = 492;
export const RegistAcctType = 493;
export const Designation = 494;
export const TaxAdvantageType = 495;
export const RegistRejReasonText = 496;
export const FundRenewWaiv = 497;
export const CashDistribAgentName = 498;
export const CashDistribAgentCode = 499;
export const CashDistribAgentAcctNumber = 500;
export const CashDistribPayRef = 501;
export const CashDistribAgentAcctName = 502;
export const CardStartDate = 503;
export const PaymentDate = 504;
export const PaymentRemitterID = 505;
export const RegistStatus = 506;
export const RegistRejReasonCode = 507;
export const RegistRefID = 508;
export const RegistDtls = 509;
export const NoDistribInsts = 510;
export const RegistEmail = 511;
export const DistribPercentage = 512;
export const RegistID = 513;
export const RegistTransType = 514;
export const ExecValuationPoint = 515;
export const OrderPercent = 516;
export const OwnershipType = 517;
export const NoContAmts = 518;
export const ContAmtType = 519;
export const ContAmtValue = 520;
export const ContAmtCurr = 521;
export const OwnerType = 522;
export const PartySubID = 523;
export const NestedPartyID = 524;
export const NestedPartyIDSource = 525;
export const SecondaryClOrdID = 526;
export const SecondaryExecID = 527;
export const OrderCapacity = 528;
export const OrderRestrictions = 529;
export const MassCancelRequestType = 530;
export const MassCancelResponse = 531;
export const MassCancelRejectReason = 532;
export const TotalAffectedOrders = 533;
export const NoAffectedOrders = 534;
export const AffectedOrderID = 535;
export const AffectedSecondaryOrderID = 536;
export const QuoteType = 537;
export const NestedPartyRole = 538;
export const NoNestedPartyIDs = 539;
export const TotalAccruedInterestAmt = 540;
export const MaturityDate = 541;
export const UnderlyingMaturityDate = 542;
export const InstrRegistry = 543;
export const CashMargin = 544;
export const NestedPartySubID = 545;
export const Scope = 546;
export const MDImplicitDelete = 547;
export const CrossID = 548;
export const CrossType = 549;
export const CrossPrioritization = 550;
export const OrigCrossID = 551;
export const NoSides = 552;
export const Username = 553;
export const Password = 554;
export const NoLegs = 555;
export const LegCurrency = 556;
export const TotNoSecurityTypes = 557;
export const NoSecurityTypes = 558;
export const SecurityListRequestType = 559;
export const SecurityRequestResult = 560;
export const RoundLot = 561;
export const MinTradeVol = 562;
export const MultiLegRptTypeReq = 563;
export const LegPositionEffect = 564;
export const LegCoveredOrUncovered = 565;
export const LegPrice = 566;
export const TradSesStatusRejReason = 567;
export const TradeRequestID = 568;
export const TradeRequestType = 569;
export const PreviouslyReported = 570;
export const TradeReportID = 571;
export const TradeReportRefID = 572;
export const MatchStatus = 573;
export const MatchType = 574;
export const OddLot = 575;
export const NoClearingInstructions = 576;
export const ClearingInstruction = 577;
export const TradeInputSource = 578;
export const TradeInputDevice = 579;
export const NoDates = 580;
export const AccountType = 581;
export const CustOrderCapacity = 582;
export const ClOrdLinkID = 583;
export const MassStatusReqID = 584;
export const MassStatusReqType = 585;
export const OrigOrdModTime = 586;
export const LegSettlType = 587;
export const LegSettlDate = 588;
export const DayBookingInst = 589;
export const BookingUnit = 590;
export const PreallocMethod = 591;
export const UnderlyingCountryOfIssue = 592;
export const UnderlyingStateOrProvinceOfIssue = 593;
export const UnderlyingLocaleOfIssue = 594;
export const UnderlyingInstrRegistry = 595;
export const LegCountryOfIssue = 596;
export const LegStateOrProvinceOfIssue = 597;
export const LegLocaleOfIssue = 598;
export const LegInstrRegistry = 599;
export const LegSymbol = 600;
export const LegSymbolSfx = 601;
export const LegSecurityID = 602;
export const LegSecurityIDSource = 603;
export const NoLegSecurityAltID = 604;
export const LegSecurityAltID = 605;
export const LegSecurityAltIDSource = 606;
export const LegProduct = 607;
export const LegCFICode = 608;
export const LegSecurityType = 609;
export const LegMaturityMonthYear = 610;
export const LegMaturityDate = 611;
export const LegStrikePrice = 612;
export const LegOptAttribute = 613;
export const LegContractMultiplier = 614;
export const LegCouponRate = 615;
export const LegSecurityExchange = 616;
export const LegIssuer = 617;
export const EncodedLegIssuerLen = 618;
export const EncodedLegIssuer = 619;
export const LegSecurityDesc = 620;
export const EncodedLegSecurityDescLen = 621;
export const EncodedLegSecurityDesc = 622;
export const LegRatioQty = 623;
export const LegSide = 624;
export const TradingSessionSubID = 625;
export const AllocType = 626;
export const NoHops = 627;
export const HopCompID = 628;
export const HopSendingTime = 629;
export const HopRefID = 630;
export const MidPx = 631;
export const BidYield = 632;
export const MidYield = 633;
export const OfferYield = 634;
export const ClearingFeeIndicator = 635;
export const WorkingIndicator = 636;
export const LegLastPx = 637;
export const PriorityIndicator = 638;
export const PriceImprovement = 639;
export const Price2 = 640;
export const LastForwardPoints2 = 641;
export const BidForwardPoints2 = 642;
export const OfferForwardPoints2 = 643;
export const RFQReqID = 644;
export const MktBidPx = 645;
export const MktOfferPx = 646;
export const MinBidSize = 647;
export const MinOfferSize = 648;
export const QuoteStatusReqID = 649;
export const LegalConfirm = 650;
export const UnderlyingLastPx = 651;
export const UnderlyingLastQty = 652;
export const LegRefID = 654;
export const ContraLegRefID = 655;
export const SettlCurrBidFxRate = 656;
export const SettlCurrOfferFxRate = 657;
export const QuoteRequestRejectReason = 658;
export const SideComplianceID = 659;
export const AcctIDSource = 660;
export const AllocAcctIDSource = 661;
export const BenchmarkPrice = 662;
export const BenchmarkPriceType = 663;
export const ConfirmID = 664;
export const ConfirmStatus = 665;
export const ConfirmTransType = 666;
export const ContractSettlMonth = 667;
export const DeliveryForm = 668;
export const LastParPx = 669;
export const NoLegAllocs = 670;
export const LegAllocAccount = 671;
export const LegIndividualAllocID = 672;
export const LegAllocQty = 673;
export const LegAllocAcctIDSource = 674;
export const LegSettlCurrency = 675;
export const LegBenchmarkCurveCurrency = 676;
export const LegBenchmarkCurveName = 677;
export const LegBenchmarkCurvePoint = 678;
export const LegBenchmarkPrice = 679;
export const LegBenchmarkPriceType = 680;
export const LegBidPx = 681;
export const LegIOIQty = 682;
export const NoLegStipulations = 683;
export const LegOfferPx = 684;
export const LegOrderQty = 685;
export const LegPriceType = 686;
export const LegQty = 687;
export const LegStipulationType = 688;
export const LegStipulationValue = 689;
export const LegSwapType = 690;
export const Pool = 691;
export const QuotePriceType = 692;
export const QuoteRespID = 693;
export const QuoteRespType = 694;
export const QuoteQualifier = 695;
export const YieldRedemptionDate = 696;
export const YieldRedemptionPrice = 697;
export const YieldRedemptionPriceType = 698;
export const BenchmarkSecurityID = 699;
export const ReversalIndicator = 700;
export const YieldCalcDate = 701;
export const NoPositions = 702;
export const PosType = 703;
export const LongQty = 704;
export const ShortQty = 705;
export const PosQtyStatus = 706;
export const PosAmtType = 707;
export const PosAmt = 708;
export const PosTransType = 709;
export const PosReqID = 710;
export const NoUnderlyings = 711;
export const PosMaintAction = 712;
export const OrigPosReqRefID = 713;
export const PosMaintRptRefID = 714;
export const ClearingBusinessDate = 715;
export const SettlSessID = 716;
export const SettlSessSubID = 717;
export const AdjustmentType = 718;
export const ContraryInstructionIndicator = 719;
export const PriorSpreadIndicator = 720;
export const PosMaintRptID = 721;
export const PosMaintStatus = 722;
export const PosMaintResult = 723;
export const PosReqType = 724;
export const ResponseTransportType = 725;
export const ResponseDestination = 726;
export const TotalNumPosReports = 727;
export const PosReqResult = 728;
export const PosReqStatus = 729;
export const SettlPrice = 730;
export const SettlPriceType = 731;
export const UnderlyingSettlPrice = 732;
export const UnderlyingSettlPriceType = 733;
export const PriorSettlPrice = 734;
export const NoQuoteQualifiers = 735;
export const AllocSettlCurrency = 736;
export const AllocSettlCurrAmt = 737;
export const InterestAtMaturity = 738;
export const LegDatedDate = 739;
export const LegPool = 740;
export const AllocInterestAtMaturity = 741;
export const AllocAccruedInterestAmt = 742;
export const DeliveryDate = 743;
export const AssignmentMethod = 744;
export const AssignmentUnit = 745;
export const OpenInterest = 746;
export const ExerciseMethod = 747;
export const TotNumTradeReports = 748;
export const TradeRequestResult = 749;
export const TradeRequestStatus = 750;
export const TradeReportRejectReason = 751;
export const SideMultiLegReportingType = 752;
export const NoPosAmt = 753;
export const AutoAcceptIndicator = 754;
export const AllocReportID = 755;
export const NoNested2PartyIDs = 756;
export const Nested2PartyID = 757;
export const Nested2PartyIDSource = 758;
export const Nested2PartyRole = 759;
export const Nested2PartySubID = 760;
export const BenchmarkSecurityIDSource = 761;
export const SecuritySubType = 762;
export const UnderlyingSecuritySubType = 763;
export const LegSecuritySubType = 764;
export const AllowableOneSidednessPct = 765;
export const AllowableOneSidednessValue = 766;
export const AllowableOneSidednessCurr = 767;
export const NoTrdRegTimestamps = 768;
export const TrdRegTimestamp = 769;
export const TrdRegTimestampType = 770;
export const TrdRegTimestampOrigin = 771;
export const ConfirmRefID = 772;
export const ConfirmType = 773;
export const ConfirmRejReason = 774;
export const BookingType = 775;
export const IndividualAllocRejCode = 776;
export const SettlInstMsgID = 777;
export const NoSettlInst = 778;
export const LastUpdateTime = 779;
export const AllocSettlInstType = 780;
export const NoSettlPartyIDs = 781;
export const SettlPartyID = 782;
export const SettlPartyIDSource = 783;
export const SettlPartyRole = 784;
export const SettlPartySubID = 785;
export const SettlPartySubIDType = 786;
export const DlvyInstType = 787;
export const TerminationType = 788;
export const NextExpectedMsgSeqNum = 789;
export const OrdStatusReqID = 790;
export const SettlInstReqID = 791;
export const SettlInstReqRejCode = 792;
export const SecondaryAllocID = 793;
export const AllocReportType = 794;
export const AllocReportRefID = 795;
export const AllocCancReplaceReason = 796;
export const CopyMsgIndicator = 797;
export const AllocAccountType = 798;
export const OrderAvgPx = 799;
export const OrderBookingQty = 800;
export const NoSettlPartySubIDs = 801;
export const NoPartySubIDs = 802;
export const PartySubIDType = 803;
export const NoNestedPartySubIDs = 804;
export const NestedPartySubIDType = 805;
export const NoNested2PartySubIDs = 806;
export const Nested2PartySubIDType = 807;
export const AllocIntermedReqType = 808;
export const UnderlyingPx = 810;
export const PriceDelta = 811;
export const ApplQueueMax = 812;
export const ApplQueueDepth = 813;
export const ApplQueueResolution = 814;
export const ApplQueueAction = 815;
export const NoAltMDSource = 816;
export const AltMDSourceID = 817;
export const SecondaryTradeReportID = 818;
export const AvgPxIndicator = 819;
export const TradeLinkID = 820;
export const OrderInputDevice = 821;
export const UnderlyingTradingSessionID = 822;
export const UnderlyingTradingSessionSubID = 823;
export const TradeLegRefID = 824;
export const ExchangeRule = 825;
export const TradeAllocIndicator = 826;
export const ExpirationCycle = 827;
export const TrdType = 828;
export const TrdSubType = 829;
export const TransferReason = 830;
export const TotNumAssignmentReports = 832;
export const AsgnRptID = 833;
export const ThresholdAmount = 834;
export const PegMoveType = 835;
export const PegOffsetType = 836;
export const PegLimitType = 837;
export const PegRoundDirection = 838;
export const PeggedPrice = 839;
export const PegScope = 840;
export const DiscretionMoveType = 841;
export const DiscretionOffsetType = 842;
export const DiscretionLimitType = 843;
export const DiscretionRoundDirection = 844;
export const DiscretionPrice = 845;
export const DiscretionScope = 846;
export const TargetStrategy = 847;
export const TargetStrategyParameters = 848;
export const ParticipationRate = 849;
export const TargetStrategyPerformance = 850;
export const LastLiquidityInd = 851;
export const PublishTrdIndicator = 852;
export const ShortSaleReason = 853;
export const QtyType = 854;
export const SecondaryTrdType = 855;
export const TradeReportType = 856;
export const AllocNoOrdersType = 857;
export const SharedCommission = 858;
export const ConfirmReqID = 859;
export const AvgParPx = 860;
export const ReportedPx = 861;
export const NoCapacities = 862;
export const OrderCapacityQty = 863;
export const NoEvents = 864;
export const EventType = 865;
export const EventDate = 866;
export const EventPx = 867;
export const EventText = 868;
export const PctAtRisk = 869;
export const NoInstrAttrib = 870;
export const InstrAttribType = 871;
export const InstrAttribValue = 872;
export const DatedDate = 873;
export const InterestAccrualDate = 874;
export const CPProgram = 875;
export const CPRegType = 876;
export const UnderlyingCPProgram = 877;
export const UnderlyingCPRegType = 878;
export const UnderlyingQty = 879;
export const TrdMatchID = 880;
export const SecondaryTradeReportRefID = 881;
export const UnderlyingDirtyPrice = 882;
export const UnderlyingEndPrice = 883;
export const UnderlyingStartValue = 884;
export const UnderlyingCurrentValue = 885;
export const UnderlyingEndValue = 886;
export const NoUnderlyingStips = 887;
export const UnderlyingStipType = 888;
export const UnderlyingStipValue = 889;
export const MaturityNetMoney = 890;
export const MiscFeeBasis = 891;
export const TotNoAllocs = 892;
export const LastFragment = 893;
export const CollReqID = 894;
export const CollAsgnReason = 895;
export const CollInquiryQualifier = 896;
export const NoTrades = 897;
export const MarginRatio = 898;
export const MarginExcess = 899;
export const TotalNetValue = 900;
export const CashOutstanding = 901;
export const CollAsgnID = 902;
export const CollAsgnTransType = 903;
export const CollRespID = 904;
export const CollAsgnRespType = 905;
export const CollAsgnRejectReason = 906;
export const CollAsgnRefID = 907;
export const CollRptID = 908;
export const CollInquiryID = 909;
export const CollStatus = 910;
export const TotNumReports = 911;
export const LastRptRequested = 912;
export const AgreementDesc = 913;
export const AgreementID = 914;
export const AgreementDate = 915;
export const StartDate = 916;
export const EndDate = 917;
export const AgreementCurrency = 918;
export const DeliveryType = 919;
export const EndAccruedInterestAmt = 920;
export const StartCash = 921;
export const EndCash = 922;
export const UserRequestID = 923;
export const UserRequestType = 924;
export const NewPassword = 925;
export const UserStatus = 926;
export const UserStatusText = 927;
export const StatusValue = 928;
export const StatusText = 929;
export const RefCompID = 930;
export const RefSubID = 931;
export const NetworkResponseID = 932;
export const NetworkRequestID = 933;
export const LastNetworkResponseID = 934;
export const NetworkRequestType = 935;
export const NoCompIDs = 936;
export const NetworkStatusResponseType = 937;
export const NoCollInquiryQualifier = 938;
export const TrdRptStatus = 939;
export const AffirmStatus = 940;
export const UnderlyingStrikeCurrency = 941;
export const LegStrikeCurrency = 942;
export const TimeBracket = 943;
export const CollAction = 944;
export const CollInquiryStatus = 945;
export const CollInquiryResult = 946;
export const StrikeCurrency = 947;
export const NoNested3PartyIDs = 948;
export const Nested3PartyID = 949;
export const Nested3PartyIDSource = 950;
export const Nested3PartyRole = 951;
export const NoNested3PartySubIDs = 952;
export const Nested3PartySubID = 953;
export const Nested3PartySubIDType = 954;
export const LegContractSettlMonth = 955;
export const LegInterestAccrualDate = 956;
export const NoStrategyParameters = 957;
export const StrategyParameterName = 958;
export const StrategyParameterType = 959;
export const StrategyParameterValue = 960;
export const HostCrossID = 961;
export const SideTimeInForce = 962;
export const MDReportID = 963;
export const SecurityReportID = 964;
export const SecurityStatus = 965;
export const SettleOnOpenFlag = 966;
export const StrikeMultiplier = 967;
export const StrikeValue = 968;
export const MinPriceIncrement = 969;
export const PositionLimit = 970;
export const NTPositionLimit = 971;
export const UnderlyingAllocationPercent = 972;
export const UnderlyingCashAmount = 973;
export const UnderlyingCashType = 974;
export const UnderlyingSettlementType = 975;
export const QuantityDate = 976;
export const ContIntRptID = 977;
export const LateIndicator = 978;
export const InputSource = 979;
export const SecurityUpdateAction = 980;
export const NoExpiration = 981;
export const ExpirationQtyType = 982;
export const ExpQty = 983;
export const NoUnderlyingAmounts = 984;
export const UnderlyingPayAmount = 985;
export const UnderlyingCollectAmount = 986;
export const UnderlyingSettlementDate = 987;
export const UnderlyingSettlementStatus = 988;
export const SecondaryIndividualAllocID = 989;
export const LegReportID = 990;
export const RndPx = 991;
export const IndividualAllocType = 992;
export const AllocCustomerCapacity = 993;
export const TierCode = 994;
export const UnitOfMeasure = 996;
export const TimeUnit = 997;
export const UnderlyingUnitOfMeasure = 998;
export const LegUnitOfMeasure = 999;
export const UnderlyingTimeUnit = 1000;
export const LegTimeUnit = 1001;
export const AllocMethod = 1002;
export const TradeID = 1003;
export const SideTradeReportID = 1005;
export const SideFillStationCd = 1006;
export const SideReasonCd = 1007;
export const SideTrdSubTyp = 1008;
export const SideLastQty = 1009;
export const MessageEventSource = 1011;
export const SideTrdRegTimestamp = 1012;
export const SideTrdRegTimestampType = 1013;
export const SideTrdRegTimestampSrc = 1014;
export const AsOfIndicator = 1015;
export const NoSideTrdRegTS = 1016;
export const LegOptionRatio = 1017;
export const NoInstrumentParties = 1018;
export const InstrumentPartyID = 1019;
export const TradeVolume = 1020;
export const MDBookType = 1021;
export const MDFeedType = 1022;
export const MDPriceLevel = 1023;
export const MDOriginType = 1024;
export const FirstPx = 1025;
export const MDEntrySpotRate = 1026;
export const MDEntryForwardPoints = 1027;
export const ManualOrderIndicator = 1028;
export const CustDirectedOrder = 1029;
export const ReceivedDeptID = 1030;
export const CustOrderHandlingInst = 1031;
export const OrderHandlingInstSource = 1032;
export const DeskType = 1033;
export const DeskTypeSource = 1034;
export const DeskOrderHandlingInst = 1035;
export const ExecAckStatus = 1036;
export const UnderlyingDeliveryAmount = 1037;
export const UnderlyingCapValue = 1038;
export const UnderlyingSettlMethod = 1039;
export const SecondaryTradeID = 1040;
export const FirmTradeID = 1041;
export const SecondaryFirmTradeID = 1042;
export const CollApplType = 1043;
export const UnderlyingAdjustedQuantity = 1044;
export const UnderlyingFXRate = 1045;
export const UnderlyingFXRateCalc = 1046;
export const AllocPositionEffect = 1047;
export const DealingCapacity = 1048;
export const InstrmtAssignmentMethod = 1049;
export const InstrumentPartyIDSource = 1050;
export const InstrumentPartyRole = 1051;
export const NoInstrumentPartySubIDs = 1052;
export const InstrumentPartySubID = 1053;
export const InstrumentPartySubIDType = 1054;
export const PositionCurrency = 1055;
export const CalculatedCcyLastQty = 1056;
export const AggressorIndicator = 1057;
export const NoUndlyInstrumentParties = 1058;
export const UnderlyingInstrumentPartyID = 1059;
export const UnderlyingInstrumentPartyIDSource = 1060;
export const UnderlyingInstrumentPartyRole = 1061;
export const NoUndlyInstrumentPartySubIDs = 1062;
export const UnderlyingInstrumentPartySubID = 1063;
export const UnderlyingInstrumentPartySubIDType = 1064;
export const BidSwapPoints = 1065;
export const OfferSwapPoints = 1066;
export const LegBidForwardPoints = 1067;
export const LegOfferForwardPoints = 1068;
export const SwapPoints = 1069;
export const MDQuoteType = 1070;
export const LastSwapPoints = 1071;
export const SideGrossTradeAmt = 1072;
export const LegLastForwardPoints = 1073;
export const LegCalculatedCcyLastQty = 1074;
export const LegGrossTradeAmt = 1075;
export const MaturityTime = 1079;
export const RefOrderID = 1080;
export const RefOrderIDSource = 1081;
export const SecondaryDisplayQty = 1082;
export const DisplayWhen = 1083;
export const DisplayMethod = 1084;
export const DisplayLowQty = 1085;
export const DisplayHighQty = 1086;
export const DisplayMinIncr = 1087;
export const RefreshQty = 1088;
export const MatchIncrement = 1089;
export const MaxPriceLevels = 1090;
export const PreTradeAnonymity = 1091;
export const PriceProtectionScope = 1092;
export const LotType = 1093;
export const PegPriceType = 1094;
export const PeggedRefPrice = 1095;
export const PegSecurityIDSource = 1096;
export const PegSecurityID = 1097;
export const PegSymbol = 1098;
export const PegSecurityDesc = 1099;
export const TriggerType = 1100;
export const TriggerAction = 1101;
export const TriggerPrice = 1102;
export const TriggerSymbol = 1103;
export const TriggerSecurityID = 1104;
export const TriggerSecurityIDSource = 1105;
export const TriggerSecurityDesc = 1106;
export const TriggerPriceType = 1107;
export const TriggerPriceTypeScope = 1108;
export const TriggerPriceDirection = 1109;
export const TriggerNewPrice = 1110;
export const TriggerOrderType = 1111;
export const TriggerNewQty = 1112;
export const TriggerTradingSessionID = 1113;
export const TriggerTradingSessionSubID = 1114;
export const OrderCategory = 1115;
export const NoRootPartyIDs = 1116;
export const RootPartyID = 1117;
export const RootPartyIDSource = 1118;
export const RootPartyRole = 1119;
export const NoRootPartySubIDs = 1120;
export const RootPartySubID = 1121;
export const RootPartySubIDType = 1122;
export const TradeHandlingInstr = 1123;
export const OrigTradeHandlingInstr = 1124;
export const OrigTradeDate = 1125;
export const OrigTradeID = 1126;
export const OrigSecondaryTradeID = 1127;
export const ApplVerID = 1128;
export const CstmApplVerID = 1129;
export const RefApplVerID = 1130;
export const RefCstmApplVerID = 1131;
export const TZTransactTime = 1132;
export const ExDestinationIDSource = 1133;
export const ReportedPxDiff = 1134;
export const RptSys = 1135;
export const AllocClearingFeeIndicator = 1136;
export const DefaultApplVerID = 1137;
export const DisplayQty = 1138;
export const ExchangeSpecialInstructions = 1139;
export const UnderlyingMaturityTime = 1213;
export const LegMaturityTime = 1212;
export const MaxTradeVol = 1140;
export const NoMDFeedTypes = 1141;
export const MatchAlgorithm = 1142;
export const MaxPriceVariation = 1143;
export const ImpliedMarketIndicator = 1144;
export const EventTime = 1145;
export const MinPriceIncrementAmount = 1146;
export const UnitOfMeasureQty = 1147;
export const LowLimitPrice = 1148;
export const HighLimitPrice = 1149;
export const TradingReferencePrice = 1150;
export const SecurityGroup = 1151;
export const LegNumber = 1152;
export const SettlementCycleNo = 1153;
export const SideCurrency = 1154;
export const SideSettlCurrency = 1155;
export const CcyAmt = 1157;
export const NoSettlDetails = 1158;
export const SettlObligMode = 1159;
export const SettlObligMsgID = 1160;
export const SettlObligID = 1161;
export const SettlObligTransType = 1162;
export const SettlObligRefID = 1163;
export const SettlObligSource = 1164;
export const NoSettlOblig = 1165;
export const QuoteMsgID = 1166;
export const QuoteEntryStatus = 1167;
export const TotNoCxldQuotes = 1168;
export const TotNoAccQuotes = 1169;
export const TotNoRejQuotes = 1170;
export const PrivateQuote = 1171;
export const RespondentType = 1172;
export const MDSubBookType = 1173;
export const SecurityTradingEvent = 1174;
export const NoStatsIndicators = 1175;
export const StatsType = 1176;
export const NoOfSecSizes = 1177;
export const MDSecSizeType = 1178;
export const MDSecSize = 1179;
export const ApplID = 1180;
export const ApplSeqNum = 1181;
export const ApplBegSeqNum = 1182;
export const ApplEndSeqNum = 1183;
export const SecurityXMLLen = 1184;
export const SecurityXML = 1185;
export const SecurityXMLSchema = 1186;
export const RefreshIndicator = 1187;
export const Volatility = 1188;
export const TimeToExpiration = 1189;
export const RiskFreeRate = 1190;
export const PriceUnitOfMeasure = 1191;
export const PriceUnitOfMeasureQty = 1192;
export const SettlMethod = 1193;
export const ExerciseStyle = 1194;
export const UnderlyingExerciseStyle = 1419;
export const LegExerciseStyle = 1420;
export const OptPayoutAmount = 1195;
export const PriceQuoteMethod = 1196;
export const ValuationMethod = 1197;
export const ListMethod = 1198;
export const CapPrice = 1199;
export const FloorPrice = 1200;
export const NoStrikeRules = 1201;
export const StartStrikePxRange = 1202;
export const EndStrikePxRange = 1203;
export const StrikeIncrement = 1204;
export const NoTickRules = 1205;
export const StartTickPriceRange = 1206;
export const EndTickPriceRange = 1207;
export const TickIncrement = 1208;
export const TickRuleType = 1209;
export const NestedInstrAttribType = 1210;
export const NestedInstrAttribValue = 1211;
export const DerivativeSymbol = 1214;
export const DerivativeSymbolSfx = 1215;
export const DerivativeSecurityID = 1216;
export const DerivativeSecurityIDSource = 1217;
export const NoDerivativeSecurityAltID = 1218;
export const DerivativeSecurityAltID = 1219;
export const DerivativeSecurityAltIDSource = 1220;
export const SecondaryLowLimitPrice = 1221;
export const SecondaryHighLimitPrice = 1230;
export const MaturityRuleID = 1222;
export const StrikeRuleID = 1223;
export const DerivativeOptPayAmount = 1225;
export const EndMaturityMonthYear = 1226;
export const ProductComplex = 1227;
export const DerivativeProductComplex = 1228;
export const MaturityMonthYearIncrement = 1229;
export const MinLotSize = 1231;
export const NoExecInstRules = 1232;
export const NoLotTypeRules = 1234;
export const NoMatchRules = 1235;
export const NoMaturityRules = 1236;
export const NoOrdTypeRules = 1237;
export const NoTimeInForceRules = 1239;
export const SecondaryTradingReferencePrice = 1240;
export const StartMaturityMonthYear = 1241;
export const FlexProductEligibilityIndicator = 1242;
export const DerivFlexProductEligibilityIndicator = 1243;
export const FlexibleIndicator = 1244;
export const TradingCurrency = 1245;
export const DerivativeProduct = 1246;
export const DerivativeSecurityGroup = 1247;
export const DerivativeCFICode = 1248;
export const DerivativeSecurityType = 1249;
export const DerivativeSecuritySubType = 1250;
export const DerivativeMaturityMonthYear = 1251;
export const DerivativeMaturityDate = 1252;
export const DerivativeMaturityTime = 1253;
export const DerivativeSettleOnOpenFlag = 1254;
export const DerivativeInstrmtAssignmentMethod = 1255;
export const DerivativeSecurityStatus = 1256;
export const DerivativeInstrRegistry = 1257;
export const DerivativeCountryOfIssue = 1258;
export const DerivativeStateOrProvinceOfIssue = 1259;
export const DerivativeLocaleOfIssue = 1260;
export const DerivativeStrikePrice = 1261;
export const DerivativeStrikeCurrency = 1262;
export const DerivativeStrikeMultiplier = 1263;
export const DerivativeStrikeValue = 1264;
export const DerivativeOptAttribute = 1265;
export const DerivativeContractMultiplier = 1266;
export const DerivativeMinPriceIncrement = 1267;
export const DerivativeMinPriceIncrementAmount = 1268;
export const DerivativeUnitOfMeasure = 1269;
export const DerivativeUnitOfMeasureQty = 1270;
export const DerivativeTimeUnit = 1271;
export const DerivativeSecurityExchange = 1272;
export const DerivativePositionLimit = 1273;
export const DerivativeNTPositionLimit = 1274;
export const DerivativeIssuer = 1275;
export const DerivativeIssueDate = 1276;
export const DerivativeEncodedIssuerLen = 1277;
export const DerivativeEncodedIssuer = 1278;
export const DerivativeSecurityDesc = 1279;
export const DerivativeEncodedSecurityDescLen = 1280;
export const DerivativeEncodedSecurityDesc = 1281;
export const DerivativeSecurityXMLLen = 1282;
export const DerivativeSecurityXML = 1283;
export const DerivativeSecurityXMLSchema = 1284;
export const DerivativeContractSettlMonth = 1285;
export const NoDerivativeEvents = 1286;
export const DerivativeEventType = 1287;
export const DerivativeEventDate = 1288;
export const DerivativeEventTime = 1289;
export const DerivativeEventPx = 1290;
export const DerivativeEventText = 1291;
export const NoDerivativeInstrumentParties = 1292;
export const DerivativeInstrumentPartyID = 1293;
export const DerivativeInstrumentPartyIDSource = 1294;
export const DerivativeInstrumentPartyRole = 1295;
export const NoDerivativeInstrumentPartySubIDs = 1296;
export const DerivativeInstrumentPartySubID = 1297;
export const DerivativeInstrumentPartySubIDType = 1298;
export const DerivativeExerciseStyle = 1299;
export const MarketSegmentID = 1300;
export const MarketID = 1301;
export const MaturityMonthYearIncrementUnits = 1302;
export const MaturityMonthYearFormat = 1303;
export const StrikeExerciseStyle = 1304;
export const SecondaryPriceLimitType = 1305;
export const PriceLimitType = 1306;
export const ExecInstValue = 1308;
export const NoTradingSessionRules = 1309;
export const NoMarketSegments = 1310;
export const NoDerivativeInstrAttrib = 1311;
export const NoNestedInstrAttrib = 1312;
export const DerivativeInstrAttribType = 1313;
export const DerivativeInstrAttribValue = 1314;
export const DerivativePriceUnitOfMeasure = 1315;
export const DerivativePriceUnitOfMeasureQty = 1316;
export const DerivativeSettlMethod = 1317;
export const DerivativePriceQuoteMethod = 1318;
export const DerivativeValuationMethod = 1319;
export const DerivativeListMethod = 1320;
export const DerivativeCapPrice = 1321;
export const DerivativeFloorPrice = 1322;
export const DerivativePutOrCall = 1323;
export const ListUpdateAction = 1324;
export const LegPutOrCall = 1358;
export const LegUnitOfMeasureQty = 1224;
export const LegPriceUnitOfMeasure = 1421;
export const LegPriceUnitOfMeasureQty = 1422;
export const UnderlyingUnitOfMeasureQty = 1423;
export const UnderlyingPriceUnitOfMeasure = 1424;
export const UnderlyingPriceUnitOfMeasureQty = 1425;
export const MarketReqID = 1393;
export const MarketReportID = 1394;
export const MarketUpdateAction = 1395;
export const MarketSegmentDesc = 1396;
export const EncodedMktSegmDescLen = 1397;
export const EncodedMktSegmDesc = 1398;
export const ParentMktSegmID = 1325;
export const TradingSessionDesc = 1326;
export const TradSesUpdateAction = 1327;
export const RejectText = 1328;
export const FeeMultiplier = 1329;
export const UnderlyingLegSymbol = 1330;
export const UnderlyingLegSymbolSfx = 1331;
export const UnderlyingLegSecurityID = 1332;
export const UnderlyingLegSecurityIDSource = 1333;
export const NoUnderlyingLegSecurityAltID = 1334;
export const UnderlyingLegSecurityAltID = 1335;
export const UnderlyingLegSecurityAltIDSource = 1336;
export const UnderlyingLegSecurityType = 1337;
export const UnderlyingLegSecuritySubType = 1338;
export const UnderlyingLegMaturityMonthYear = 1339;
export const UnderlyingLegPutOrCall = 1343;
export const UnderlyingLegStrikePrice = 1340;
export const UnderlyingLegSecurityExchange = 1341;
export const NoOfLegUnderlyings = 1342;
export const UnderlyingLegCFICode = 1344;
export const UnderlyingLegMaturityDate = 1345;
export const UnderlyingLegMaturityTime = 1405;
export const UnderlyingLegOptAttribute = 1391;
export const UnderlyingLegSecurityDesc = 1392;
export const EncryptedPasswordMethod = 1400;
export const EncryptedPasswordLen = 1401;
export const EncryptedPassword = 1402;
export const EncryptedNewPasswordLen = 1403;
export const EncryptedNewPassword = 1404;
export const ApplExtID = 1156;
export const RefApplExtID = 1406;
export const DefaultApplExtID = 1407;
export const DefaultCstmApplVerID = 1408;
export const SessionStatus = 1409;
export const DefaultVerIndicator = 1410;
export const NoUsernames = 809;
export const LegAllocSettlCurrency = 1367;
export const TotNoFills = 1361;
export const NoFills = 1362;
export const FillExecID = 1363;
export const FillPx = 1364;
export const FillQty = 1365;
export const LegAllocID = 1366;
export const TradSesEvent = 1368;
export const MassActionReportID = 1369;
export const NoNotAffectedOrders = 1370;
export const NotAffectedOrderID = 1371;
export const NotAffOrigClOrdID = 1372;
export const MassActionType = 1373;
export const MassActionScope = 1374;
export const MassActionResponse = 1375;
export const MassActionRejectReason = 1376;
export const MultilegModel = 1377;
export const MultilegPriceMethod = 1378;
export const LegVolatility = 1379;
export const DividendYield = 1380;
export const LegDividendYield = 1381;
export const CurrencyRatio = 1382;
export const LegCurrencyRatio = 1383;
export const LegExecInst = 1384;
export const ContingencyType = 1385;
export const ListRejectReason = 1386;
export const NoTrdRepIndicators = 1387;
export const TrdRepPartyRole = 1388;
export const TrdRepIndicator = 1389;
export const TradePublishIndicator = 1390;
export const ApplReqID = 1346;
export const ApplReqType = 1347;
export const ApplResponseType = 1348;
export const ApplTotalMessageCount = 1349;
export const ApplLastSeqNum = 1350;
export const NoApplIDs = 1351;
export const ApplResendFlag = 1352;
export const ApplResponseID = 1353;
export const ApplResponseError = 1354;
export const RefApplID = 1355;
export const ApplReportID = 1356;
export const RefApplLastSeqNum = 1357;
export const ApplNewSeqNum = 1399;
export const ApplReportType = 1426;
export const Nested4PartySubIDType = 1411;
export const Nested4PartySubID = 1412;
export const NoNested4PartySubIDs = 1413;
export const NoNested4PartyIDs = 1414;
export const Nested4PartyID = 1415;
export const Nested4PartyIDSource = 1416;
export const Nested4PartyRole = 1417;
export const LegLastQty = 1418;
export const SideExecID = 1427;
export const OrderDelay = 1428;
export const OrderDelayUnit = 1429;
export const VenueType = 1430;
export const RefOrdIDReason = 1431;
export const OrigCustOrderCapacity = 1432;
export const RefApplReqID = 1433;
export const ModelType = 1434;
export const ContractMultiplierUnit = 1435;
export const LegContractMultiplierUnit = 1436;
export const UnderlyingContractMultiplierUnit = 1437;
export const DerivativeContractMultiplierUnit = 1438;
export const FlowScheduleType = 1439;
export const LegFlowScheduleType = 1440;
export const UnderlyingFlowScheduleType = 1441;
export const DerivativeFlowScheduleType = 1442;
export const FillLiquidityInd = 1443;
export const SideLiquidityInd = 1444;
export const NoRateSources = 1445;
export const RateSource = 1446;
export const RateSourceType = 1447;
export const ReferencePage = 1448;
export const RestructuringType = 1449;
export const Seniority = 1450;
export const NotionalPercentageOutstanding = 1451;
export const OriginalNotionalPercentageOutstanding = 1452;
export const UnderlyingRestructuringType = 1453;
export const UnderlyingSeniority = 1454;
export const UnderlyingNotionalPercentageOutstanding = 1455;
export const UnderlyingOriginalNotionalPercentageOutstanding = 1456;
export const AttachmentPoint = 1457;
export const DetachmentPoint = 1458;
export const UnderlyingAttachmentPoint = 1459;
export const UnderlyingDetachmentPoint = 1460;
export const NoTargetPartyIDs = 1461;
export const TargetPartyID = 1462;
export const TargetPartyIDSource = 1463;
export const TargetPartyRole = 1464;
export const SecurityListID = 1465;
export const SecurityListRefID = 1466;
export const SecurityListDesc = 1467;
export const EncodedSecurityListDescLen = 1468;
export const EncodedSecurityListDesc = 1469;
export const SecurityListType = 1470;
export const SecurityListTypeSource = 1471;
export const NewsID = 1472;
export const NewsCategory = 1473;
export const LanguageCode = 1474;
export const NoNewsRefIDs = 1475;
export const NewsRefID = 1476;
export const NewsRefType = 1477;
export const StrikePriceDeterminationMethod = 1478;
export const StrikePriceBoundaryMethod = 1479;
export const StrikePriceBoundaryPrecision = 1480;
export const UnderlyingPriceDeterminationMethod = 1481;
export const OptPayoutType = 1482;
export const NoComplexEvents = 1483;
export const ComplexEventType = 1484;
export const ComplexOptPayoutAmount = 1485;
export const ComplexEventPrice = 1486;
export const ComplexEventPriceBoundaryMethod = 1487;
export const ComplexEventPriceBoundaryPrecision = 1488;
export const ComplexEventPriceTimeType = 1489;
export const ComplexEventCondition = 1490;
export const NoComplexEventDates = 1491;
export const ComplexEventStartDate = 1492;
export const ComplexEventEndDate = 1493;
export const NoComplexEventTimes = 1494;
export const ComplexEventStartTime = 1495;
export const ComplexEventEndTime = 1496;
export const StreamAsgnReqID = 1497;
export const StreamAsgnReqType = 1498;
export const NoAsgnReqs = 1499;
export const MDStreamID = 1500;
export const StreamAsgnRptID = 1501;
export const StreamAsgnRejReason = 1502;
export const StreamAsgnAckType = 1503;
export const StreamAsgnType = 1617;
export const RelSymTransactTime = 1504;
export const AllocGrossTradeAmt = 2300;
